import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PackageInstalledAppsService } from '@services/packages/package-installed-apps.service';
import { PackageService } from '@services/packages/package.service';
import { Models } from '@ibexfusion/models';
import { DynamicContentService } from '@services/dynamic-content/dynamic-content.service';
import { DynamicContentEntranceService } from '@services/dynamic-content/dynamic-content-entrance.service';

@Component({
  selector: 'app-content-selection',
  templateUrl: './content-selection.component.html',
  styleUrl: './content-selection.component.scss',
  providers: [PackageInstalledAppsService, PackageService, DynamicContentService, DynamicContentEntranceService],
  standalone: false
})
export class ContentSelectionComponent implements OnInit {

  private packageId: string;
  public appColumns = [{ prop: 'translations.0.appTitle', name: 'Applikationstitel' }];
  public entryColumns = [{ prop: 'title', name: 'Titel' }];
  apps: Models.PackageInstalledApp[] = [];
  app: Models.PackageInstalledApp
  entries: Models.DynamicContent[] = [];
  entryChain: Models.DynamicContent[] = [];

  constructor(
    private dialogRef: MatDialogRef<ContentSelectionComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private appService: PackageInstalledAppsService,
    private packageService: PackageService, private entranceService: DynamicContentEntranceService, private entryService: DynamicContentService
  ) {
    this.packageId = data.packageId;
  }

  async ngOnInit() {
    const pak = await this.packageService.get(this.packageId);
    let apps: any = await this.appService.find(0, 100, { _id: { $in: pak.installedAppIds } });
    apps = (apps?.data || []).filter(a => !!a.dynamicContentEntranceId);
    const entrances = (await this.entranceService.find(0, 1000, { _id: { $in: apps.map(a => a.dynamicContentEntranceId) }})).data;
    const contentTypeBlackList = ['ticker', 'breaking-news', 'social-media', 'screensaver', 'voting', 'public-transport'];
    this.apps = apps.filter(a => !contentTypeBlackList.includes(entrances.find(e => e?._id === a?.dynamicContentEntranceId)?.type));
  }

  async selectApp(event: any) {
    this.app = this.apps[event.index];
    const entrance = await this.entranceService.get(this.app.dynamicContentEntranceId);
    this.entries = entrance?.children?.length ? (await this.entryService.find(0, 10000, { _id: { $in: entrance.children } })).data : [];
  }

  async selectEntry(event: any) {
    this.entryChain.push(this.entries[event.index]);
    this.entries = this.entries[event.index].children.length ? (await this. entryService.find(0, 10000, { _id: { $in: this.entries[event.index].children } })).data : [];
  }

  async reset(index = -1) {
    if (index === -1) {
      this.entryChain = [];
      this.app = null;
      this.entries = [];
    } else {
      this.entryChain.splice(index);
      if (index === 0) {
        const entrance = await this.entranceService.get(this.app.dynamicContentEntranceId);
        this.entries = (await this. entryService.find(0, 10000, { _id: { $in: entrance.children } })).data;
      } else {
        this.entries = (await this. entryService.find(0, 10000, { _id: { $in: this.entryChain[this.entryChain.length - 1].children } })).data;
      }
    }
  }

  abort() {
    this.dialogRef.close();
  }

  save() {
    this.dialogRef.close(this.entryChain[this.entryChain.length - 1]._id);
  }
}
